import { Injectable } from '@angular/core';

import { EnvironmentService } from '../../shared/environment.service';
import { IAppConfig } from '../../shared/interfaces';
import { environment } from '../../../environments/environment';
import { ConfigurationStorageService } from '../../shared/configuration-storage.service';

@Injectable({
    providedIn: 'root'
})
export class WebEnvironmentService extends EnvironmentService {
    constructor(private configStorage: ConfigurationStorageService) {
        super();
    }

    isElectron(): boolean {
        return false;
    }

    getConfiguration(): IAppConfig {
        return {
            apiServerBaseUrl: environment.apiServerBaseUrl,
            ...this.configStorage.getAppConfig()
        } as IAppConfig;
    }

    saveConfiguration(appConfig: IAppConfig): void {
        this.configStorage.setAppConfig(appConfig);
    }

    loadConfiguration(): string | null {
        return null;
    }

    runExecutable(
        // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
        executablePath: string,
        // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
        cmdLine: string,
        // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
        callback: (outTxt: string | undefined, errTxt: string | undefined, errMsg: string | undefined) => void
    ): void {
        throw new Error('runExecutable is not supported by web environment');
    }
}
